var util = angular.module('gymsystem.util');
util.controller('LokSettingsCtrl', ['$rootScope', '$scope', 'server', 'Setting', '$controller', 'alertProvider', function ($rootScope, $scope, server, Setting, $controller, alertProvider) {
        $controller('SettingsCtrl', { $scope: $scope });
        var lok_sport;
        $scope.item = {};
        $scope.getUrl = '/api/lok/setting/get';
        $scope.postUrl = '/api/lok/setting/set';
        var resposibleVisible = function (field) {
            var group = _.findWhere($scope.fields, { name: '_group_toggle' });
            return group.value ? field.name == 'responsible_group_id' : field.name == 'responsible_user_id';
        };
        var sendOptions = [
            { id: 1, name: '1. Varje lag har sin aktivitet per match' },
            { id: 2, name: '2. Varje match blir en aktivitet , alla lag på den matchen hamnar under samma aktivitet' },
            { id: 3, name: '3. En aktivitet per arena, alla matcher/aktiviteter som varit på samma arena/resurs vid samma tid skickas in som en gemensam aktivitet' },
            { id: 4, name: '4. En aktivitet per tid, alla matcher/aktiviteter som varit på samma vid samma tid och samma aktivitetstyp skickas in som en gemensam aktivitet' }
        ];
        $scope.fields = [
            { name: 'org_sport_ref', title: 'Sport', required: true, type: 'select', useId: true, options: function () { return lok_sport; } },
            { name: 'autosend', title: 'Auto send', required: false, type: 'checkbox' },
            {
                name: 'sendmode',
                title: 'Hur ska aktiviteterna rapporteras? ',
                required: false,
                type: 'select',
                useId: true,
                options: function () { return sendOptions; }
            }, {
                name: '_group_toggle', title: 'Chose group', required: false, type: 'checkbox', skipChangedCheck: true, setValue: function () { return !!$scope.item.responsible_group_id; }
            }, {
                name: 'responsible_group_id',
                title: 'Responsible',
                required: false,
                type: 'group',
                useId: true,
                visible: resposibleVisible
            }, {
                name: 'responsible_user_id',
                title: 'Responsible',
                required: false,
                type: 'customer',
                itemTypes: ['staff'],
                useId: true,
                visible: resposibleVisible
            }
        ];
        server.get('/api/lok/get_sport').then(function (result) { lok_sport = result; })["finally"](function () {
            $scope.getSettings();
        });
    }]);
